import React, {Component} from 'react';
import * as messageConstants from "../../shared/messages";

class ImportFile extends Component {
  constructor(props) {
    super(props);
    this.state = {value: ''};
  }

  render() {
    return (
        <div className="action-block">
          <div className="row">
            <div className={this.props.imageWidth}>
              <img alt={this.props.imageName}
                   src={this.props.imageName}
                   width="100%" height="60%"/>
            </div>
            <div className="helper-text">
              <div>320 px w x 60 px h max</div>
              <div>PNG, GIF or JPG</div>
              <div>{this.props.fileSize.description} max</div>
            </div>
          </div>
          <input type="file"
                 name="image"
                 accept=".png, .jpeg, .gif, .jpg"
                 className="inputfile"
                 ref={input => this.inputUploadImage = input}
                 onChange={this.props.handleSelectedImage}
                 value={this.state.value}/>
          <a role="button"
             onClick={() => this.inputUploadImage.click()}>
            {messageConstants.UPLOAD}
          </a>
        </div>
    );
  }
}

export default ImportFile;



// WEBPACK FOOTER //
// ./src/components/CustomizeGlobalIdpSettings/ImportFile.js